angular.module('lf.common')

.directive('redeemForm', function (redeemService, scrolls, popupsService, gtmService, $http) {
  return {
    restrict: 'A',
    require: '^?form',
    link: function (scope, el, attrs, FormCtrl) {
      el.on('submit', function (e) {
        FormCtrl.$touched = true;
        e.preventDefault();

        var redeemCode = "";
        el.find('input[type=text]').each(function (i, el) {
          redeemCode += $(el).val();
        });

        if($(el).attr('name') === 'redeemTRUForm') {
          FormCtrl.$redeemCodeDuplicated = (scope.redeemCode.replace(/-/g, '') === redeemCode);
        }

        if (FormCtrl.$valid && !FormCtrl.$redeemCodeDuplicated) {
          if($(el).attr('name') === 'redeemForm') {
            scope.redeemCode = redeemCode.slice(0, 4);
            redeemCode = redeemCode.slice(4);

            while (redeemCode.length > 0) {
              scope.redeemCode += '-' + redeemCode.slice(0, 4);
              redeemCode = redeemCode.slice(4);
            }
          }

          var params = {
            url: el.attr('action'),
            serializedData: el.serialize()
          }
          
          var isMobileUI = lf.data.xhr.client.mobileUI;

          scope.requesting = true;
          
          redeemService.submitRedeemCode(params)
            .success(function (data) {
              console.log("redeemService.submitSuccess");
              console.log(data);
  
              if (data) {
                if (data.success) {
                  scrolls.scrollTop('main');
  
                  scope.redeemResponseData = data;
                  scope.shop.accountBalance = data.accountBalance;
                  scope.hideSearchAndAccountBalance = true;
                  var redeemCodeType = data.redeemCodeType;
                  switch (redeemCodeType) {
                    case "valueCodeSuccess":
                  	// value card success
                      if(!isMobileUI) {
                        FormCtrl.$touched = false;
  	                    popupsService.show('valueCodeSuccess');
  	                    scope.clearRedeemCode('uiRedeemCode');
  	                    scope.clearRedeemState();
                      }
                      gtmService.pushRedeemSuccess(data.redeemCodeType, data.pinType, data.redeemValue);
                      break;
  
                    case "giftCodeStep2":
                  	// gift code step 2
                  	if(!isMobileUI) {
        	                popupsService.show('giftCard');
                  	}
                  	gtmService.pushRedeemStart(data.redeemCodeType, data.pinType);
                      break;
  
                    case "bonusCodeSuccess":
                    case "genericCodeSuccess":
                  	// bonus card success, generic code success
                      var fetchDeviceInventoryUrl = data.fetchDeviceInventoryUrl;
                      // 1. LFConnectMode Only :: Trigger fetch device inventory
                      if (fetchDeviceInventoryUrl) {
                        $http.get(fetchDeviceInventoryUrl);
                      }
  
                      // + '&codeTYPE=' + data.redeemCodeType
                      // 2. Navigate the user to redeem confirmation screen
                      var url = data.redeemConfirmPageUrl + (data.skuIds ? '?skuIds=' + data.skuIds : '');
                      url = encodeURI(url);
                      window.location.href = url;
                      break;
                      
                    case "subsetCodeStep2":
                    case "truCodeStep3":
                  	// subsetStep2
                  	// truStep3
                      var redeemSubsetUrl = data.redeemSubsetUrl;
                      if (redeemSubsetUrl) {
                      	redeemSubsetUrl = redeemSubsetUrl + '&pinType=' + data.pinType;
                      	window.location.href = redeemSubsetUrl;
                      }
                      break;
                      
                    case "truCodeStep2":
                  	// truStep2
                      FormCtrl.$redeemCodeDuplicated = false;
                      scope.truCodeEntered = true;
                  }
                } else {
                  scrolls.scrollTop('main');
  
                  if (data.errors) {
                    gtmService.pushFormError('redeemForm', data.errors);
                    FormCtrl.$invalidRedeemCode = true;
                    scope.redeemErrors = data.errors;
                  }
                }
              }
            })
            .error(function (data){
              gtmService.pushFormError('redeemForm', 'submit redeem http error');
              console.log('http error');
              delete scope.redeemResponseData;
            })
            .finally(function () {
              scope.requesting = false;
            });
        } else {
          var errorMessages = [];
          _.each(FormCtrl.$error, function (errorCtrls, errorkey) {
            switch (errorkey) {
              case 'required':
                var fieldsNames = [];
                _.each(errorCtrls, function (ctrl) {
                  console.log(ctrl.$name.slice(0, 8), (ctrl.$name.slice(0, 8) == 'uiRedeem'));
                  console.log(fieldsNames.indexOf('uiRedeemCode'));

                  if (ctrl.$name.slice(0, 8) == 'uiRedeem') {
                    if (fieldsNames.indexOf('uiRedeemCode') === -1) {
                      fieldsNames.push('uiRedeemCode');
                    }
                  } else {
                    fieldsNames.push(ctrl.$name);
                  }
                });

                console.log(fieldsNames);

                var message = 'Field';
                message += (fieldsNames.length > 1) ? 's ' : ' ';
                message += fieldsNames.join(', ') +  ' are required';

                errorMessages.push(message);
                break;
            }
          });

          gtmService.pushFormError(FormCtrl.$name, errorMessages);
        }

        el.on('focus', 'input[name]:not([type=submit])', function (e) {
          var $input = $(e.target);

          var name = $input.attr('name');
          var field = FormCtrl[name];

          if (!field || field.$pristine) return;

          $input.on('input', onInput);

          function onInput () {
            if (!FormCtrl.$invalid && !FormCtrl.$invalidRedeemCode && !FormCtrl.$redeemCodeDuplicated) return;
            FormCtrl.$invalidRedeemCode = false;
            FormCtrl.$invalid = false;
            FormCtrl.$redeemCodeDuplicated = false;

            $input.on('blur', onBlur);
            scope.$apply();
          }

          function onBlur () {
            //field.$editing = false;
            $input.off('input', onInput);
            $input.off('blur', onBlur);
            scope.$apply();
          }
        });

        scope.$apply();
      });
    }
  }
});
